import { ChangeEvent } from 'react';
import { SwitchIndicator, withStyles } from 'vopay';
import styles from './PermissionToggle.module.scss';

const cn = withStyles(styles);

type PermissionToggleProps = {
  name: string;
  checked: boolean;
  disabled: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

export default function PermissionToggle({ name, checked, disabled, onChange }: PermissionToggleProps) {
  return (
    <>
      <SwitchIndicator checked={checked} disabled={disabled} />

      <input
        className={cn('hiddenCheckbox')}
        // Stable Cypress hook. Not an `id`: two editors can share a page (see `formID`), so a
        // `checkbox-<code>` id would collide — the wrapping row label handles association instead.
        data-testid={`checkbox-${name}`}
        type="checkbox"
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
    </>
  );
}
